import { Navigate } from "react-router-dom";

export default function ProductionReportRedirect() {
  return (
    <Navigate to="/reports/production/by-part/per-part" replace />
  );
}
